var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5C6.70156 1.5 2 6.20156 2 12C2 17.7984 6.70156 22.5 12.5 22.5C18.2984 22.5 23 17.7984 23 12C23 6.20156 18.2984 1.5 12.5 1.5ZM12.5 20.7188C7.68594 20.7188 3.78125 16.8141 3.78125 12C3.78125 7.18594 7.68594 3.28125 12.5 3.28125C17.3141 3.28125 21.2188 7.18594 21.2188 12C21.2188 16.8141 17.3141 20.7188 12.5 20.7188Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3608 11.6979L10.4209 6.65883C10.3653 6.61803 10.2994 6.59349 10.2306 6.58794C10.1618 6.58239 10.0928 6.59605 10.0313 6.6274C9.96984 6.65874 9.91827 6.70655 9.88236 6.76548C9.84645 6.82442 9.82761 6.89217 9.82795 6.96118V17.0393C9.82795 17.3464 10.1748 17.5198 10.4209 17.3417L17.3608 12.3026C17.4087 12.2681 17.4477 12.2227 17.4746 12.1701C17.5015 12.1175 17.5156 12.0593 17.5156 12.0003C17.5156 11.9412 17.5015 11.883 17.4746 11.8304C17.4477 11.7779 17.4087 11.7324 17.3608 11.6979ZM11.3233 14.8385V9.16196L15.2303 12.0003L11.3233 14.8385Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.76bf01737b57c4afd14733d1bb0f141e.svg";
export { ForwardRef as ReactComponent };